import cn from 'clsx'
import * as React from 'react'
import type { DropdownOption } from 'types/ui'
import NativeTagsSelector from 'components/common/native-tags-selector'
import FilterRow from '../filter-row'
type Props = {
  chosenTags: number[]
  updateSearchParams: (...args: Array<any>) => any
  isPhone: boolean
  disabled: boolean
  scrollContainer?: HTMLDivElement | null | undefined
}
export default function NativeTagsFilter(props: Props): React.ReactNode {
  const _onSelectAllClick = () =>
    props.updateSearchParams({
      nativeTags: [],
    })

  const _onTagsFilterChange = (tags: DropdownOption[]) =>
    props.updateSearchParams({
      nativeTags: tags.map(t => t.value),
    })

  const { chosenTags, scrollContainer } = props
  const allTagsClass = cn('SearchResults_FilterOption', {
    'is-active': chosenTags.length === 0,
    SearchResults_FilterOption_Expandable_AlignTop: !props.isPhone,
  })
  const tagFilter = (
    <NativeTagsSelector
      disabled={props.disabled}
      onChange={_onTagsFilterChange}
      selectedTags={chosenTags}
      placeholder="Select tags"
      scrollContainer={scrollContainer}
    />
  )
  return (
    <FilterRow caption="Filter by tags:" reducedMargins>
      <a className={allTagsClass} onClick={_onSelectAllClick}>
        Track tags
      </a>
      {tagFilter}
    </FilterRow>
  )
}
